import {
  CardMarketConditionCodeType,
  CardTraderConditionValueType,
} from "magic-shared-types";

export function getMatchingConditionsCardTrader(
  condition: CardTraderConditionValueType
): CardTraderConditionValueType[] {
  switch (condition) {
    case "Poor":
      return [
        "Poor",
        "Played",
        "Moderately Played",
        "Slightly Played",
        "Near Mint",
      ];
    case "Played":
      return ["Played", "Moderately Played", "Slightly Played", "Near Mint"];
    case "Moderately Played":
      return ["Moderately Played", "Slightly Played", "Near Mint"];
    case "Slightly Played":
      return ["Slightly Played", "Near Mint"];
    case "Near Mint":
      return ["Near Mint"];
    default:
      return [];
  }
}

export function getMatchingConditionsCardMarket(
  condition: CardMarketConditionCodeType
): CardMarketConditionCodeType[] {
  switch (condition) {
    case "PO": // Poor
      return ["PO", "PL", "LP", "GD", "EX", "NM"];
    case "PL": // Played
      return ["PL", "LP", "GD", "EX", "NM"];
    case "LP": // Played
      return ["LP", "GD", "EX", "NM"];
    case "GD": // Moderately Played
      return ["GD", "EX", "NM"];
    case "EX": // Slightly Played
      return ["EX", "NM"];
    case "NM": // Near Mint
      return ["NM"];
    default:
      return [];
  }
}
